// Zone.js configuration flags — must be set before zone.js is loaded.
// These disable zone.js patching for specific browser APIs that don't need it,
// improving performance in the firm portal.
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__Zone_disable_on_property = true;
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ["scroll", "mousemove"];
(window as any).__Zone_enable_cross_context_check = true;
